import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTeam = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "4em",
	height: "4em",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 0h24v24H0z",
		fill: "none"
	}), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: .8,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M12 7.5a3.5 3.5 0 1 1-7 0a3.5 3.5 0 0 1 7 0Z" }),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "round",
				d: "M13.5 11a3.5 3.5 0 1 0 0-7"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M13.143 20H3.857C2.831 20 2 19.233 2 18.286C2 15.919 4.079 14 6.643 14h3.714a4.9 4.9 0 0 1 2.786.857"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "round",
				d: "M19 14v6m3-3h-6"
			})
		]
	})]
});
export default SvgTeam;
